module.exports = __webpack_public_path__ + "static/media/power-ranking-menu-icon.b63c8f93.svg";